import { stringify as generateQueryString } from 'qs';
import { NOT_FOUND } from 'http-status-codes';
import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';
import ErrorsFactory from '../../utils/errorsFactory';


const handleNotFoundHttpError = response => {
  if (response && response.status === NOT_FOUND) {
    throw ErrorsFactory.NotFoundError('Help Page not found');
  }

  return response;
};

export const fetchMainPageButtons = async pageUrl => await fetch(
  `${Config.endpoints.MAIN_PAGE_BUTTONS}?${generateQueryString({ pageUrl })}`
)
  .then(handleErrors({ errorMessage: 'Fetching help contents failed' }))
  .then(parseAsJson);

export const fetchAllContentsForExport = async () => await fetch(
  `${Config.endpoints.HELP_CONTENTS_FOR_EXPORT}`
)
  .then(handleErrors({ errorMessage: 'Fetching help contents for export failed' }))
  .then(parseAsJson);

export const sendContentsForImport = async contents => await fetch(
  `${Config.endpoints.HELP_CONTENTS_FOR_EXPORT}`,
  {
    method: 'POST',
    body: JSON.stringify(contents),

  }
)
  .then(handleErrors({ errorMessage: 'Importing help content failed' }))
  .then(parseAsJson);

export const fetchHelpContent = async contentId => await fetch(
  Config.endpoints.HELP_CONTENT
    .replace(/:contentId/, contentId)
)
  .then(handleNotFoundHttpError)
  .then(handleErrors({ errorMessage: 'Fetching page help content failed' }))
  .then(parseAsJson);

export const fetchDocumentation = async searchedText => await fetch(
  Config.endpoints.SEARCH_DOCUMENTATION
    .replace(/:searchedText/, searchedText)
)
  .then(handleErrors({ errorMessage: 'Fetching help documentation failed' }))
  .then(parseAsJson);

export const updateHelpContent = async (contentId, { title, content, contentText, clients }) => await fetch(
  Config.endpoints.HELP_CONTENT.replace(/:contentId/, contentId),
  {
    method: 'PUT',
    body: JSON.stringify({
      title,
      content,
      contentText,
      clients,
    }),
  }
);

export const createHelpContent = async ({ pageUrl, title, sectionName, settings }) => await fetch(
  Config.endpoints.INSERT_HELP_CONTENT,
  {
    method: 'POST',
    body: JSON.stringify({
      pageUrl,
      title,
      sectionId: sectionName,
      ...settings,
    }),
  }
);

export const deleteHelpContent = async contentId => await fetch(
  Config.endpoints.HELP_CONTENT.replace(/:contentId/, contentId),
  {
    method: 'DELETE',
  }
);
